import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// Isola crashes de render de uma seção para que não derrubem a aplicação inteira
// (tela branca). Em telas com várias abas, use `key` para resetar ao trocar de aba.
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary capturou um erro de render:', error, info);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="p-5 text-center text-muted">
          Ocorreu um erro ao carregar esta seção. Tente recarregar a página.
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
